import axios from "axios";
import { api } from "~/router/apiConfig";

export function create(request) {
  return axios.post(api.path("contract.store"), request);
}

export function remove(id) {
  return axios.delete(api.path("contract.delete", { id: id }));
}

export function turnOn(id) {
  return axios.put(
    api.path("contract.turnOn", { id: id })
  );
}

export function turnOff(id) {
  return axios.put(
    api.path("contract.turnOff", { id: id })
  );
}

export function updateContract(id, request) {
  return axios.put(
    api.path("contract.update", { id: id }),
    request
  );
}

export function index(isJoined = false) {
  return axios.get(api.path("contract.index"), {
    params: {
      is_joined: isJoined
    }
  });
}
export function contractsBalance() {
  return axios.get(api.path("contract.balance"));
}

export function updateContractUser(contractId, userId, request) {
  return axios.put(
    api.path("contractUser.update", {
      contractId: contractId,
      userId: userId
    }),
    request
  );
}
//
export function deleteContractUser(contractId, userId, request) {
  return axios.delete(
    api.path("contractUser.delete", {
      contractId: contractId,
      userId: userId
    }),
    request
  );
}


export function show(id) {
  return axios.get(
    api.path("contract.show", { id: id }));
}

